/**
 * Utility functions for the Rehash component
 */

/**
 * Capitalizes the first letter of a string
 * @param {string} text - The text to capitalize
 * @returns {string} The capitalized text
 */
export const capitalizeFirstLetter = (text) => {
    if (text != null && text.length > 0) {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    } else {
        return '';
    }
};

/**
 * Formats a number with commas
 * @param {string} x - The number to format
 * @returns {string} The formatted number
 */
export const numberWithCommas = (x) => {
    if (x != null) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
        return '';
    }
};
